import script from "./CloseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CloseButton.vue?vue&type=script&setup=true&lang=ts"

import "./CloseButton.vue?vue&type=style&index=0&id=a3b1258a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3b1258a"]])

export default __exports__